import { Tabs } from '@mantine/core'
import { IconUsers } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { FixedPageTitle } from '@/components/layout/PageWithFixedToolbar/FixedPageTitle'
import { PageWithFixedToolbar } from '@/components/layout/PageWithFixedToolbar/PageWithFixedToolbar'
import { useHasPermissions } from '@/permissions/useHasPermissions'
import { CrossCameraNestedPath, RouterPath } from '@/router/paths'
import { CrudAction, Resource } from '@/types/permissions'

export const CrossCameraPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [canReadDevices] = useHasPermissions(Resource.Devices, [
    CrudAction.Read
  ])

  const currentTab =
    Object.values(CrossCameraNestedPath).find((tab) =>
      location.pathname.endsWith(`/${tab}`)
    ) ?? CrossCameraNestedPath.pipelines

  const handleTabChange = (value: string | null) => {
    void navigate(
      `${RouterPath.crossCamera}/${value || CrossCameraNestedPath.pipelines}`
    )
  }

  return (
    <PageWithFixedToolbar
      maxWidth={1400}
      toolbar={
        <FixedPageTitle
          title={<FormattedMessage id="crossCamera.title" />}
          icon={<IconUsers size={24} color="var(--mantine-color-blue-6)" />}
        />
      }
    >
      <Tabs
        value={currentTab}
        mb="xl"
        variant="outline"
        styles={{ tabLabel: { fontWeight: 600 } }}
        onChange={handleTabChange}
      >
        <Tabs.List>
          {canReadDevices && (
            <Tabs.Tab value={CrossCameraNestedPath.installation}>
              <FormattedMessage id="crossCamera.tabs.installation" />
            </Tabs.Tab>
          )}

          <Tabs.Tab value={CrossCameraNestedPath.pipelines}>
            <FormattedMessage id="crossCamera.tabs.pipelines" />
          </Tabs.Tab>

          <Tabs.Tab value={CrossCameraNestedPath.people}>
            <FormattedMessage id="crossCamera.tabs.people" />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <Outlet />
    </PageWithFixedToolbar>
  )
}
